import React from 'react';
import './MainChatAiWindow.css';

export const AiProcessingSteps = React.memo(({ processingSteps }) => {
  if (!processingSteps?.length) return null;

  return (
    <div className="ai-processing-simple-stepper">
      {processingSteps.map((step, index) => {
        const isLastStep = index === processingSteps.length - 1;
        const isActive = isLastStep;
        const isCompleted = !isActive;
        const isLastLine = index === processingSteps.length - 2;
        return (
          <div key={step.id || index} className="ai-simple-step-item">
            <div className="ai-simple-step-dot-col">
              <span
                className={`ai-simple-step-dot${isActive ? ' active' : ''}${isCompleted ? ' completed' : ''}`}
              ></span>
              {/* Vertical line between steps, from center bottom of dot to next dot */}
              {!isLastLine && (
                <span
                  className={`ai-simple-step-line${isActive ? ' active' : ''}${isCompleted ? ' completed' : ''}`}
                ></span>
              )}
            </div>
            <div className={`ai-simple-step-text${isActive ? ' active' : ''}`}>{step.text}</div>
          </div>
        );
      })}
    </div>
  );
});

AiProcessingSteps.displayName = 'AiProcessingSteps';
